import { domainEvent } from "@lookiero/messaging";
const TRANSLATION_SYNCED = "translation_synced";
const translationSynced = ({ aggregateId, ...payload }) => ({
    ...domainEvent({ aggregateId, name: TRANSLATION_SYNCED }),
    ...payload,
});
const isTranslationSynced = (event) => event.name === TRANSLATION_SYNCED;
export { TRANSLATION_SYNCED, translationSynced, isTranslationSynced };
